export default __webpack_public_path__ + "static/media/file-upload.e9773faf.svg";